<div class="chat-message" [ngClass]="{ 'unread': !!lastUnreadIndex && message.index > lastUnreadIndex && !isMessageMine }">
  <span class="chat-message-date">{{formattedDate(message.dateCreated)}}</span>
  <!-- <span class="chat-message-date">{{message.dateCreated | date:'shortTime'}}</span> -->
  <span class="p1 chat-message-body">{{message.body}}</span>
</div>
